export * from './formular-detail.component';
export * from './formular-detail.component.module';